import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-active-or-deactive-pricing',
  templateUrl: './active-or-deactive-pricing.component.html',
  styleUrls: ['./active-or-deactive-pricing.component.scss']
})
export class ActiveOrDeactivePricingComponent implements OnInit {

  color: ThemePalette = 'primary';

  constructor() { }

  ngOnInit() {
  }

}
